var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-status",class:{
    'subscription-status_error': _vm.currentStatus === 'Ожидает оплаты',
  }},[_c('div',{staticClass:"subscription-status__wrapper"},[_c('p',{staticClass:"subscription-status__duration"},[_vm._v(" "+_vm._s(_vm.formattedDistance)+" ")]),_c('p',{staticClass:"subscription-status__status",class:{
        'subscription-status__status_error':
          _vm.currentStatus === 'Ожидает оплаты',
      }},[_vm._v(" "+_vm._s(_vm.currentStatus)+" ")])]),(_vm.formattedDistance !== '0 дней')?_c('div',{staticClass:"subscription-status__expired-at"},[_vm._v(" до "+_vm._s(_vm.formattedDate)+" МСК ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }